module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"pageTitle":"Time To Change: il progetto e i 17 obiettivi","description":"Time To Change: il progetto e i 17 obiettivi per sviluppo sostenibile"},"en":{"pageTitle":"Time To Change: the 17 goals","description":"Time To Change: the 17 goals for Sustainable Development."}}')
  delete Component.options._Ctor
}
